import React, { useState } from "react";
import {
  Box,
  TableCell,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { FaEye, FaTimes } from "react-icons/fa";

const TruncatedTableCell = ({ content, title, maxLength = 30, sx = {} }) => {
  const [open, setOpen] = useState(false);

  const truncatedContent =
    content && content.length > maxLength
      ? `${content.substring(0, maxLength)}...`
      : content;

  const shouldShowViewButton = content && content.length > maxLength;

  return (
    <>
      <TableCell sx={sx}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            variant="body2"
            sx={{
              flex: 1,
              lineHeight: 1.4,
              wordBreak: "break-word",
            }}
          >
            {truncatedContent}
          </Typography>
          {shouldShowViewButton && (
            <IconButton
              size="small"
              onClick={() => setOpen(true)}
              sx={{
                minWidth: "24px",
                width: "24px",
                height: "24px",
                color: "#059669",
                "&:hover": {
                  backgroundColor: "#f0f9f5",
                },
              }}
            >
              <FaEye size={12} />
            </IconButton>
          )}
        </Box>
      </TableCell>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "12px",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <DialogTitle
          sx={{
            pb: 2,
            borderBottom: "1px solid #f0f0f0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600, color: "#1f2937" }}>
            {title}
          </Typography>
          <IconButton
            onClick={() => setOpen(false)}
            size="small"
            sx={{
              color: "#6b7280",
              "&:hover": {
                backgroundColor: "#f3f4f6",
              },
            }}
          >
            <FaTimes />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ pt: 3, pb: 2 }}>
          <Typography
            variant="body1"
            sx={{
              lineHeight: 1.6,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              color: "#374151",
            }}
          >
            {content}
          </Typography>
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            pb: 3,
            borderTop: "1px solid #f0f0f0",
          }}
        >
          <Button
            onClick={() => setOpen(false)}
            variant="contained"
            sx={{
              backgroundColor: "#059669",
              "&:hover": {
                backgroundColor: "#047857",
              },
              textTransform: "none",
              borderRadius: "8px",
            }}
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TruncatedTableCell;
